export function normalizeGender(gender: string | null | undefined): string {
    if (gender == null) {
        return "noinfo"
    }
    switch (gender.toLowerCase()) {
        case "no info": return "noinfo"
        default: return gender.toLowerCase()
    }
}